import { TCoreCheckboxOptions } from '../types/options';

export const buildSwitchCssVars = (palette: TCoreCheckboxOptions): Record<string, string> => {
    const margin = palette.margin ?? {};

    const vars: Record<string, string | undefined> = {
        // margin
        '--cw-switch-margin-top': px(margin.top),
        '--cw-switch-margin-right': px(margin.right),
        '--cw-switch-margin-bottom': px(margin.bottom),
        '--cw-switch-margin-left': px(margin.left),
        // geometry — track
        '--cw-switch-width': px(palette.width),
        '--cw-switch-height': px(palette.height),
        // geometry — thumb
        '--cw-switch-thumb-size': px(palette.thumbSize),
        '--cw-switch-thumb-size-checked': px(palette.thumbSizeChecked),
        '--cw-switch-thumb-offset': px(palette.thumbOffset),
        '--cw-switch-thumb-offset-checked': px(palette.thumbOffsetChecked),
        // border
        '--cw-switch-track-border-width': px(palette.borderStroke),
        '--cw-switch-track-border-radius': px(palette.borderRadius),
        // track — default (unchecked)
        '--cw-switch-track-bg': palette.surfaceContainerHighest ?? palette.surface,
        '--cw-switch-track-border': palette.outline,
        // track — checked
        '--cw-switch-track-bg-checked': palette.main,
        '--cw-switch-track-border-checked': palette.main,
        // track — pressed
        '--cw-switch-track-bg-pressed': palette.pressed?.main,
        '--cw-switch-track-border-pressed': palette.pressed?.main,
        // track — disabled
        '--cw-switch-track-bg-disabled': palette.disabled?.surface ?? palette.disabled?.surfaceContainerHighest ?? palette.surfaceContainerHighest,
        '--cw-switch-track-border-disabled': palette.disabled?.outline ?? palette.outline,
        // track — disabled+checked
        '--cw-switch-track-bg-disabled-checked': palette.disabled?.main ?? palette.surfaceContainerHighest,
        '--cw-switch-track-border-disabled-checked': palette.disabled?.main ?? palette.outline,
        // thumb — default (unchecked)
        '--cw-switch-thumb-bg': palette.outline,
        // thumb — checked
        '--cw-switch-thumb-bg-checked': palette.mainContainer,
        // thumb — pressed
        '--cw-switch-thumb-bg-pressed': palette.pressed?.mainContainer ?? palette.pressed?.onMain,
        // thumb — disabled
        '--cw-switch-thumb-bg-disabled': palette.disabled?.outline ?? palette.onSurface,
        // thumb — disabled+checked
        '--cw-switch-thumb-bg-disabled-checked': palette.disabled?.mainContainer ?? palette.onSurface,
    };

    return Object.fromEntries(Object.entries(vars).filter((entry): entry is [string, string] => entry[1] !== undefined));
};

const px = (value: unknown): string | undefined => (typeof value === 'number' ? `${value}px` : undefined);
